import { useEffect } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import useCookieScript from "use-cookiescript-hook";
import { ContentHeader } from "@/components/ui/header";
import { Footer } from "@/components/ui/footer";
import { useAuth } from "@/hooks/use-auth";
import { Spinner } from "@/components/ui/spinner";
import { cn } from "@/utils/cn";
export function ContentLayout({ authLayout }) {
    const { user, claims, loading } = useAuth();
    const location = useLocation();

    const subdomain = window.location.hostname.split(".")[0];
    const interestForm = subdomain == "www";

    useCookieScript(
        "//cdn.cookie-script.com/s/ff6988cfa851a6071f9e54526419ba4d.js",
        {
            position: "head-top",
        },
    );

    useEffect(() => {
        return () => {
            document
                .querySelectorAll('script[src*="cdn.cookie-script.com"]')
                .forEach((element) => element.remove());

            // CookieScript's generated elements
            document
                .querySelectorAll('[id^="cookiescript"]')
                .forEach((element) => element.remove());
        };
    }, []);

    if (loading) {
        return (
            <div className="flex h-dvh w-dvw items-center justify-center">
                <Spinner size="md" />
            </div>
        );
    }

    if (!user && location.pathname.startsWith("/clinicians/book")) {
        return (
            <Navigate
                to="/login"
                replace
                state={{
                    from: "booking",
                    booking: location.state,
                }}
            />
        );
    }

    return (
        <div
            className={cn(
                "grid min-h-dvh max-w-dvw grid-rows-[auto_1fr_auto]",
                authLayout
                    ? "[--header-height:7.25rem]"
                    : "[--header-height:6.5rem]",
            )}
        >
            <ContentHeader
                user={user}
                claims={claims}
                interestForm={interestForm}
                authLayout={authLayout}
            />
            <main className="relative flex flex-col">
                <div className="fixed inset-0 top-20 -z-10 bg-linear-to-t/oklch from-beige from-30% via-[oklch(0.9894_0.0119_101.48)] via-70% to-white" />
                <Outlet />
            </main>
            <Footer interestForm={interestForm} />
        </div>
    );
}
